import React, { Component } from 'react';
import _ from "lodash";
import FemaleProfile from './../../assets/images/user_profile_female.jpg';
import MaleProfile from "./../../assets/images/user_profile_male.jpg";
import {Form, Control, Field, Errors, Fieldset} from "react-redux-form";
import Loading from "../loading";
import {isRequired, required, isEmail, email, isRfc, isCurp} from "../field_validations";
import {allUpper, toInt} from "../parsers";
import GreetingsSelect from "../forms/greeting_select";

class UserEditForm extends Component {
	render() {
		const { status, roles, users, entities, match } = this.props;
		return <Form model="users.edit"
		             validators={{
			             '': {passwordsMatch: (vals) => vals.password === vals.password_confirmation}
		             }}
		             onSubmit={(users) => this._handleSubmit(users)}
		             onSubmitFailed={(error) => {this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger'); console.log('error', error)}}>
				<div className="columns is-centered is-multiline">
					<div className="column is-10">
						<div className="columns">
							<div className="column is-3 has-text-centered">
								{users.edit.image ? (_.isObject(users.edit.image) ?
									<i className="fa fa-picture-o fa-4x" /> :
									<figure className="image is-1by1">
										<img src={`${users.edit.image}?${Date.now()}`} alt={users.edit.name} />
									</figure>) :
									(users.edit.sex === 'H' ?
											<figure className="image is-1by1">
												<img src={MaleProfile} alt={users.edit.name} />
											</figure> :
											<figure className="image is-1by1">
												<img src={FemaleProfile} alt={users.edit.name} />
											</figure>
									)}
							</div>
							<div className="column">
								<div className="field has-addons">
									<div className="control">
										<label htmlFor="title" className="label">Saludo <span className="small has-text-danger">*</span></label>
										<div className="select">
											<Control model=".title" id="title" component={GreetingsSelect} validateOn="change" errors={{required}} />
										</div>
										<Errors model=".title" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'Obligatorio'}} />
									</div>
									<div className="control is-expanded">
										<label htmlFor="name" className="label">Nombre(s) <span className="small has-text-danger">*</span></label>
										<Control.text model=".name" className="input" id="name" errors={{isRequired}} validateOn="change" />
										<Errors model=".name" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El nombre es obligatorio'}} />
									</div>
								</div>

								<div className="field is-grouped">
									<div className="control is-expanded">
										<label htmlFor="last_name" className="label">Primer Apellido <span className="small has-text-danger">*</span></label>
										<Control.text model=".last_name" className="input" id="last_name" errors={{isRequired}} validateOn="change" />
										<Errors model=".last_name" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El apellido es obligatorio'}} />
									</div>

									<div className="control is-expanded">
										<label htmlFor="slast_name" className="label">Segundo Apellido</label>
										<Control.text model=".slast_name" className="input" id="slast_name" value={users.edit.slast_name ? users.edit.slast_name:''} />
									</div>
								</div>

								<div className="field is-grouped">
									<div className="control">
										<label htmlFor="sex" className="label">Sexo <span className="small has-text-danger">*</span></label>
										<Field model=".sex" className="select" errors={{isRequired}} validateOn="change">
											<select id="sex">
												<option value=" " defaultValue>--- Sexo ---</option>
												<option value="M">Mujer</option>
												<option value="H">Hombre</option>
											</select>
										</Field>
										<Errors model=".sex" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El sexo es obligatorio'}} />
									</div>

									<div className="control is-expanded">
										<label htmlFor="scholarship" className="label">Escolaridad</label>
										<Control.text model=".scholarship" className="input" id="scholarship" value={users.edit.scholarship ? users.edit.scholarship:''}/>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="column is-10">
						<div className="field is-grouped">
							<div className="control is-expanded">
								<label htmlFor="rfc" className="label">RFC</label>
								<Control.text model=".rfc" className="input" id="rfc" value={users.edit.rfc ? users.edit.rfc:''} errors={{ isRfc}} validateOn="change" parser={ allUpper }/>
								<Errors model=".rfc" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{ isRfc: 'RFC inválido. '}} />
							</div>
							<div className="control is-expanded">
								<label htmlFor="curp" className="label">CURP</label>
								<Control.text model=".curp" className="input" id="curp" value={users.edit.curp ? users.edit.curp:''} errors={{ isCurp}} validateOn="change" parser={ allUpper }/>
								<Errors model=".curp" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isCurp: 'CURP inválida. '}} />
							</div>
						</div>

						<div className="field is-grouped">
							<div className="control is-expanded">
								<label htmlFor="email" className="label">Email principal <span className="small has-text-danger">*</span> <small className="has-text-grey">(para ingresar a la plataforma)</small></label>
								<Control.text model=".email" className="input" id="email" placeholder="usuario@dominio.com" errors={{required, isEmail}} validateOn="change" />
								<Errors model=".email" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El email es obligatorio. ', isEmail: 'El email es inválido'}} />
							</div>
							<div className="control is-expanded">
								<label htmlFor="email_2" className="label">Email secundario</label>
								<Control.text className="input" type="email" model=".email_2" id="email_2" placeholder="usuario@dominio.com" errors={{email}} />
								<Errors model=".email_2" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{email: 'El email es inválido'}} />
							</div>
						</div>

						<div className="field is-grouped">
							<div className="control is-expanded">
								<label htmlFor="password" className="label">Contraseña</label>
								<Control.password model=".password" id="password" name="password" className="input" placeholder="Contraseña" />
							</div>

							<div className="control is-expanded">
								<label htmlFor="password_confirmation" className="label">Confirmar Contraseña</label>
								<Control.password model=".password_confirmation" id="password_confirmation" name="password_confirmation" className="input" />
								<Errors model="users.edit" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{passwordsMatch: 'Las contraseñas no coinciden'}} />
							</div>
						</div>

						<div className="message is-dark is-small">
							<div className="message-body">
								Si no deseas alterar tu contraseña, deja en blanco los campos de contraseña.
							</div>
						</div>

						<div className="field is-grouped">
							<div className="control is-expanded">
								<label htmlFor="telephone" className="label">Teléfono</label>
								<Control.text model=".telephone" className="input" id="telephone" value={users.edit.telephone ? users.edit.telephone:''}/>
							</div>

							<div className="control">
								<label htmlFor="extension" className="label">Extensión</label>
								<Control.text model=".extension" className="input" id="extension" value={users.edit.extension ? users.edit.extension:''}/>
							</div>

							<div className="control is-expanded">
								<label htmlFor="telephone_2" className="label">Teléfono secundario</label>
								<Control.text model=".telephone_2" id="telephone_2" className="input" value={users.edit.telephone_2 ? users.edit.telephone_2:''}/>
							</div>
						</div>

						<div className="field is-grouped">
							{match.params.id ?
								<div className="control">
									<label htmlFor="roles" className="label">Perfil <span className="small has-text-danger">*</span></label>
									<div className="select">
										<Control.select id="roles" model=".role_id" errors={{required}} parser={ toInt } validateOn="change" changeAction={(model, values) => this._changeProfile(model, values)}>
											<option value=" " defaultValue>--- Perfil ---</option>
											{_.map(roles.list, (row, k) => {
												return (
													<option key={k} value={row.id}>{row.display ? row.display : row.name}</option>
												)
											})}
										</Control.select>
									</div>
									<Errors model=".role_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El perfil es obligatorio'}} />
								</div>
								:''}
							<div className="control">
								<label htmlFor="status" className="label">Estatus <span className="small has-text-danger">*</span></label>
								<Field model=".status_id" className="select" errors={{required}} validateOn="change">
									<select id="status">
										<option defaultValue>--- Estatus ---</option>
										{_.map(status.data, (stat, k) => {
											return <option value={stat.id} key={k}>{stat.name}</option>
										})}
									</select>
								</Field>
								<Errors model=".status_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El estatus es obligatorio'}} />
							</div>
						</div>

						{entities.isFetching ? <Loading /> : this._instances() }

						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<button type="button" className="button is-danger" onClick={() => this.props.history.push('/usuarios')}>
									Regresar
								</button>
							</div>

							<div className="control">
								<Control.button model="users.edit" className="button is-success" disabled={this._validateSave()}>Guardar</Control.button>
							</div>
						</div>

						<p className="has-text-grey has-text-right is-small">Los campos indicados con <span className="small has-text-danger">*</span> son obligatorios.</p>
					</div>
				</div>
			</Form>
	}

	constructor() {
		super();
		this.state = {
			type: null
		}
	}

	componentWillReceiveProps(props) {
		const { users, roles } = props;
		let role = users.edit.role_id;
		let type = _.find(roles.list, {id: role});
		if(type) {
			this.setState({ type: type.agenciable_type })
		}
	}

	_instances() {
		switch(this.state.type) {
			case 'imef':
				return <StateSelect states={{...this.props.entities.list}} />
			case 'imm':
				return <MunicipalitySelect states={{...this.props.entities.list}} municipalities={{...this.props.municipalities}} func={this.props.fetchMunicipalities} change={this.props.change} state={this.props.users.agencies ? this.props.users.agencies.state_id:undefined} />
			case 'cdm':
				return <MunicipalitySelectCdm states={{...this.props.entities.list}} municipalities={{...this.props.municipalities}} func={this.props.fetchMunicipalities} change={this.props.change} state={this.props.users.agencies ? this.props.users.agencies.state_id:undefined} />
			case 'federal':
				return <StatesCombo states={{...this.props.entities.list}} />;
			default:
				return <p></p> ;
		}
	}

	_handleSubmit(values) {
		const { agencies } = this.props.users;
		this.props.userSave({edit: {...values}, agencies});
	}

	_changeProfile(model, value) {
		const { roles } = this.props;
		let id =_.findIndex(roles.list, (o) => { return o.id === value});
		if(id > -1) {
			let type = roles.list[id].agenciable_type;
			this.props.fetchEntities();
			this.setState({type})
		}

		this.props.change(model, value);
		this.props.change('users.agencies', '');
		/*return dispatch => {
			dispatch(actions.change('users.agencies', ''));
			dispatch(actions.change(model, value));
		}*/
	}

	_validateSave(){
		const {users} = this.props;
		let uc = _.find(users.permissions, (o) => {return o==='Create'});
		let uu = _.find(users.permissions, (o) => {return o==='Update'});

		if(!_.isEmpty(users.edit) && users.edit.id){
			if(uu){
				return false;
			}else {
				return true;
			}
		}else if(!_.isEmpty(users.edit) && _.isEmpty(users.edit.id)){
			if(uc){
				return false;
			}else {
				return true;
			}
		}else {
			return true;
		}
	}
}

class StateSelect extends Component {
	render() {
		const { states } = this.props;
		return (
			<Fieldset model="users.agencies" className="field">
				<div className="control">
					<label htmlFor="" className="label">Entidades</label>
					<div className="select">
						<Control.select id="state" model=".id" errors={{required}} parser={ toInt }>
							<option value="" defaultValue>--- Estados ---</option>
							{_.map(states, (row, k) => {
								return <option key={k} value={row.id}>{row.name}</option>
							})}
						</Control.select>
						<Errors model=".id" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'Debes elegir una entidad.'}} />
					</div>
				</div>
			</Fieldset>
		)
	}
}

class StatesCombo extends Component {
	render() {
		const { states } = this.props;
		return (
			<Fieldset model="users.agencies">
				<div className="field is-grouped is-grouped-multiline">
					{_.map(states, (row, k) => {
						return (
							<div className="control" key={k}>
								<label className="label" htmlFor={`state-${row.id}`}>
									<Control.checkbox model={`[${row.id}]`} id={`state-${row.id}`} value={row.id} />
									{row.name}
								</label>
							</div>
						)
					})}
				</div>
			</Fieldset>
		)
	}
}

class MunicipalitySelect extends Component {
	render() {
		const { states, municipalities } = this.props;
		return (
			<Fieldset model="users.agencies" className="field is-grouped">
				<div className="control">
					<label htmlFor="state-select" className="label">Estados</label>
					<Field model=".state_id" className="select" parser={ toInt } errors={{required}} changeAction={(model, values) => this._stateFilter(model, values)}>
						<select id="state-select" ref="states">
							<option value=" " defaultValue>--- Estados ---</option>
							{_.map(states, (row, k) => {
								return <option key={k} value={row.id}>{row.name}</option>
							})}
						</select>
						<Errors model=".state_id" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'Debes elegir una entidad.'}} />
					</Field>
				</div>

				<div className="control">
					<label htmlFor="municipality" className="label">Municipios</label>
					<div className={`select${municipalities.isFetching ? ' is-loading' : ''}`}>
						<Control.select id="municipality" model=".id" errors={{required}} parser={ toInt } disabled={municipalities.isFetching || _.isEmpty(municipalities.list)}>
							<option value="" defaultValue>--- Municipios ---</option>
							{_.map(_.filter(municipalities.list, {modality_id: 2}), (mun, j) => {
								return <option key={j} value={mun.id}>{mun.name}</option>
							})}
						</Control.select>
						<Errors model=".id" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'Debes elegir un municipio.'}} />
					</div>
				</div>
			</Fieldset>
		)
	}

	_stateFilter(model, value) {
		this.props.func(value);
		this.props.change('users.agencies', {state_id: value});
		/*return dispatch => {
			dispatch(actions.change('users.agencies', {state_id: value}));
		}*/
	}

	componentWillMount() {
		if(this.props.state) {
			this.props.func(this.props.state);
		}
	}
}

class MunicipalitySelectCdm extends Component {
	render() {
		const { states, municipalities } = this.props;
		return (
			<Fieldset model="users.agencies" className="field is-grouped">
				<div className="control">
					<label htmlFor="state-select" className="label">Estados</label>
					<Field model=".state_id" className="select" parser={ toInt } errors={{required}} changeAction={(model, values) => this._stateFilter(model, values)}>
						<select id="state-select" ref="states">
							<option value=" " defaultValue>--- Estados ---</option>
							{_.map(states, (row, k) => {
								return <option key={k} value={row.id}>{row.name}</option>
							})}
						</select>
						<Errors model=".state_id" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'Debes elegir una entidad.'}} />
					</Field>
				</div>

				<div className="control">
					<label htmlFor="municipality" className="label">Municipios</label>
					<div className={`select${municipalities.isFetching ? ' is-loading' : ''}`}>
						<Control.select id="municipality" model=".id" errors={{required}} parser={ toInt } disabled={municipalities.isFetching || _.isEmpty(municipalities.list)}>
							<option value="" defaultValue>--- Municipios ---</option>
							{_.map(_.filter(municipalities.list, {modality_id: 3}), (mun, j) => {
								return <option key={j} value={mun.id}>{mun.name}</option>
							})}
						</Control.select>
						<Errors model=".id" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'Debes elegir un municipio.'}} />
					</div>
				</div>
			</Fieldset>
		)
	}

	_stateFilter(model, value) {
		this.props.func(value);
		this.props.change('users.agencies', {state_id: value});
		/*return dispatch => {
			dispatch(actions.change('users.agencies', {state_id: value}));
		}*/
	}

	componentWillMount() {
		if(this.props.state) {
			this.props.func(this.props.state);
		}
	}
}

export default UserEditForm;



// WEBPACK FOOTER //
// ./src/elements/users/form.jsx